import { IStateSliceDefaults, StateSliceName } from '../store.models';

import { ITeamStateModel } from './team.models';

export const teamStateDefaults: IStateSliceDefaults<ITeamStateModel> = Object.freeze({
    sliceName: StateSliceName.TEAM,
    defaults: {
        teamsById: undefined,
        selectedTeamId: undefined
    }
});
